import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { RootStateOrAny, useSelector } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { isNull, isNullOrUndefined } from "../../../../utils/utilityFunctions";
import BrandPerformanceTrendTile from "../BrandPerformanceTrendTile";
import BrandPerformanceTableTile from "../BrandPerformanceTableTile";

import { getTPVATableData, getTPVATrendData } from "../../../../api";

interface Props extends RouteComponentProps {
  diff: number;
  granularity: string;
}

const TPVAContent = withRouter((props: Props) => {
  const { diff, history, granularity } = props;
  const params = useSelector((state: RootStateOrAny) => state.parameters);
  // fetch the trend and average data
  const {
    data: chartData,
    isFetching: loadingTPVATrendData, // call data using react-query
    refetch: refetchTPVATrendData,
  } = useQuery(["tpvaTrendData", granularity, history.location.search], () => getTPVATrendData(params), { enabled: false });

  const {
    data: tableData,
    isFetching: loadingTPVATableData, // call data using react-query
    refetch: refetchTPVATableData,
  } = useQuery(["tpvaTableData", granularity, history.location.search], () => getTPVATableData(params), {
    enabled: false,
  });

  // when the url changes, refetch the data
  useEffect(() => {
    refetchTPVATableData();
    refetchTPVATrendData();
  }, [history.location.search]);

  const columns = [
    {
      id: "model",
      Header: `Model`,
      accessor: "model",
      defaultCanSort: true,
      sortDescFirst: true,
      sortType: "alphanumericIgnoreCase",
      Cell: (props: { value: string }) => {
        const { value } = props;

        return value;
      },
    },
    {
      Header: "TPVA",
      accessor: `tpva`,
      id: "tpva",
      defaultCanSort: true,
      defaultSortDesc: true,
      sortDescFirst: true,
      sortType: "alphanumericCustom",
      Cell: ({ value }: { value: number }) => {
        return isNullOrUndefined(value) ? "n/a" : `${value?.toLocaleString()}`;
      },
    },
  ];

  return (
    <div className="brand-market-main-content">
      <BrandPerformanceTrendTile
        title="TPVA Trend"
        chartId="tpvaTrendChart"
        chartData={chartData}
        loadingTrend={loadingTPVATrendData}
        diff={diff}
        chartGranularity={granularity}
        showTPVAchartText={true}
      />
      <BrandPerformanceTableTile
        title="TPVA Average"
        tableId="tpvaTable"
        tableData={tableData}
        columns={columns}
        loadingTable={loadingTPVATableData}
        initialSortCol={{ id: "tpva", desc: true }}
      />
    </div>
  );
});

export default TPVAContent;
